import './register.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvRadioGroup, AvRadio, AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Alert, Button } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { IRootState } from 'app/shared/reducers';
import { reset, handleRegisterOrgINFO, handleRegisterCCVC } from './register.reducer';

import { plugin, ENP, IND, download_plugin, LINK_TERM_OF_USE, SUCCESS, ERROR, Rester_Type } from 'app/config/constants';
import RegisterBottom from './registerBottom';
import { width } from '@fortawesome/free-solid-svg-icons/faSave';

export interface IRegisterAccountProps extends StateProps, DispatchProps {
  userType: string;
}

export interface IRegisterAccountState {
  redirectInfo: boolean;
  email: string;
  name: string;
  visible: boolean;
  color: string;
  message: string;
  disableButtonReg: boolean;
}

export class RegisterAccountORG extends React.Component<IRegisterAccountProps, IRegisterAccountState> {
  state: IRegisterAccountState = {
    redirectInfo: false,
    //userType: ''
    email: '',
    name: '',
    visible: false,
    color: 'danger',
    message: '',
    disableButtonReg: false
  };

  componentDidMount() {
    // window['checkPlugin']();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.resultRegCCVC !== nextProps.resultRegCCVC) {
      const { resultRegCCVC } = nextProps;
      console.log(JSON.stringify(resultRegCCVC));
      if (resultRegCCVC && resultRegCCVC.status === SUCCESS) {
        this.setState({
          disableButtonReg: false,
          redirectInfo: true
          // name: resultRegOrgInfo.name
        });
      } else if (resultRegCCVC && resultRegCCVC.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message:
            resultRegCCVC.message && resultRegCCVC.message !== ERROR ? resultRegCCVC.message : translate('register.messages.error.fail')
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  registerAccount = (event, values) => {
    this.setState({
      email: values.email
    });
    if (this.props.userType === Rester_Type.EMAIL || this.props.userType === Rester_Type.MOBILE) {
      this.props.handleRegisterCCVC(values.email, this.props.userType);
    } else {
      this.setState({
        redirectInfo: true
      });
    }
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  renderRedirect = () => {
    if (this.state.redirectInfo) {
      if (this.props.userType === Rester_Type.EMAIL || this.props.userType === Rester_Type.MOBILE) {
        return (
          <Redirect
            push
            to={{
              pathname: '/sendOtp',
              state: {
                mobile: this.props.userType === Rester_Type.MOBILE ? this.state.email : '',
                id: this.state.email,
                email: this.props.userType === Rester_Type.EMAIL ? this.state.email : '',
                type: this.props.userType
              }
            }}
          />
        );
      } else {
        return (
          <Redirect
            push
            to={{
              pathname: '/info/registeracc',
              state: {
                email: this.state.email,
                name: this.state.name
              }
            }}
          />
        );
      }
    }
  };

  renderInput = () => {
    if (this.props.userType === Rester_Type.MOBILE) {
      return (
        <AvField
          name="email"
          label={
            <span>
              Nhập Số điện thoại đăng ký tài khoản
              <strong> *</strong>
            </span>
          }
          placeholder="Nhập Số điện thoại"
          validate={{
            required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
            number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') },
            minLength: { value: 10, errorMessage: translate('global.messages.validate.mobile.minlength') },
            maxLength: { value: 11, errorMessage: translate('global.messages.validate.mobile.maxlength') }
          }}
        />
      );
    } else if (this.props.userType === Rester_Type.EMAIL) {
      return (
        <AvField
          name="email"
          label={
            <span>
              Nhập Email đăng ký tài khoản
              <strong> *</strong>
            </span>
          }
          placeholder="Nhập Email"
          type="email"
          validate={{
            required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
            email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
          }}
        />
      );
    } else {
      return (
        <AvField
          name="email"
          label={
            <span>
              Nhập Email tổ chức
              <strong> *</strong>
            </span>
          }
          placeholder="Nhập Email"
          type="email"
          validate={{
            required: { value: true, errorMessage: translate('register.messages.validate.email.required') },
            email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
          }}
        />
      );
    }
  };

  render() {
    return (
      <div>
        {this.renderRedirect()}
        <Row className="justify-content-center">
          <Col style={{ flex: 1 }}>
            <h2 className="text-center text-register" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <ul className="tabs">
            <li className="active">
              <a>
                Chào mừng bạn đến với Hệ thống - Nền tảng quản lý định danh và xác thực
                <div>Bộ Nông nghiệp và Môi trường</div>
              </a>
            </li>
          </ul>
        </Row>
        <Row className="justify-content-center avfield-font" style={{ marginTop: '30px' }}>
          <Col md="8">
            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
            <AvForm id="register-form" onValidSubmit={this.registerAccount}>
              {this.renderInput()}
              <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>
              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={false} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultRegOrgInfo: storeState.register.resultRegOrgInfo,
  currentLocale: storeState.locale.currentLocale,
  config: storeState.applicationProfile.config,
  resultRegCCVC: storeState.register.resultRegCCVC
});

const mapDispatchToProps = { handleRegisterOrgINFO, reset, handleRegisterCCVC };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterAccountORG);
